import { MoveToBottomIcon, TriangleDownIcon } from "@primer/octicons-react";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { handleDownloadApkg, handleDownloadCsv } from "../TextPage";

const DownloadSplitButton: React.FC<{ uid: string }> = ({ uid }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  return (
    <div className="download-split" ref={ref}>
      <button className="download-main" onClick={() => handleDownloadApkg(uid)}>
        <MoveToBottomIcon size={16} />
        Download
      </button>
      <button
        className="download-toggle"
        aria-label="Download options"
        onClick={() => setOpen((v) => !v)}
      >
        <TriangleDownIcon size={16} />
      </button>
      {open && (
        <div className="download-menu">
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(false);
              handleDownloadApkg(uid);
            }}
          >
            Download Anki
          </a>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setOpen(false);
              handleDownloadCsv(uid);
            }}
          >
            Download CSV
          </a>
        </div>
      )}
    </div>
  );
};

export default DownloadSplitButton;
